import { FieldTypes } from 'forms-utils-lib/constants/formField/FieldTypeMapping';
import createFormFieldOption from 'forms-utils-lib/formField/utils/createFormFieldOption';
import { FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
export const PRIVACY_ADS_CONSENT_NAME = 'hs_data_privacy_ads_consent';
export const HS_DATA_PRIVACY_ADS_CONSENT_FIELD = {
  name: PRIVACY_ADS_CONSENT_NAME,
  label: '',
  fieldType: FieldTypes.SINGLE_CHECKBOX,
  description: 'This property captures ads consents from forms and is used by consentmanager to create / update associated data privacy consent objects',
  groupName: 'contactinformation',
  objectTypeId: FormFieldPropertyObjectTypesIds.CONTACT,
  options: [createFormFieldOption({
    label: 'Yes',
    value: 'true',
    displayOrder: 0
  }), createFormFieldOption({
    label: 'No',
    value: 'false',
    displayOrder: 1
  })],
  readOnlyValue: true,
  readOnlyDefinition: true,
  externalOptions: false,
  hubspotDefined: true,
  allowedObjectTypes: []
};